@if (building) {
  <div id="driver-metrics-static" class="driver-static-container">
    <div class="content">
      <div class="filter-panel">
        <div class="filter-content">
          <app-adm-static-filter [building]='building'></app-adm-static-filter>
        </div>
      </div>
    </div>
    <div class='flex justify-center'>
      <app-driver-metrics-static-table [building]="building"></app-driver-metrics-static-table>
    </div>
  </div>
}
